import React from 'react'

const Footer = () => {
    return (
        <div className="footer">
            <p>bas de page</p>
        </div>
    )
}

export default Footer
